import script from "./LfTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./LfTable.vue?vue&type=script&setup=true&lang=ts"

import "./LfTable.vue?vue&type=style&index=0&id=3b5c2356&scoped=true&lang=less"

import exportComponent from "E:\\twl\\workspace\\auxiliary-ts-cms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b5c2356"]])

export default __exports__